import React from "react";
import "./Dpu_Exciting_Opportunity.css";

const Dpu_Exciting_Opportunity = () => {
  return (
    <section className="Dpu_Exciting_Opportunity">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 d-flex justify-content-center align-items-center">
            <h2>
              Exciting{" "}
              <span>
                <br />
                Opportunities with
              </span>{" "}
              <br />
              the Global <br />
              Immersion
              <br />
              Program
            </h2>
          </div>
          <div className="col-lg-7">
            <img
              src="/assets/images/dpu_mca/opportunities/photo.png"
              className="img-fluid"
              alt="Collage of group photos shows students visiting international campuses, landmarks, corporate offices, and attending auditorium sessions, highlighting global exposure and industry engagement opportunities."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dpu_Exciting_Opportunity;
